'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  justify-content: center;\n  position: relative;\n  white-space: nowrap;\n'], ['\n  display: flex;\n  justify-content: center;\n  position: relative;\n  white-space: nowrap;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _icon = require('@hixme-ui/icon');

var _icon2 = _interopRequireDefault(_icon);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mainButtonStyles = {
  borderTopRightRadius: '0',
  borderBottomRightRadius: '0'
};

var toggleButtonStyles = {
  borderTopLeftRadius: '0',
  borderBottomLeftRadius: '0',
  marginLeft: '-1px',
  minWidth: 'auto',
  padding: '5px'
};

var MenuButtonContainer = _styledComponents2.default.div(_templateObject);

var MenuButton = function (_Component) {
  (0, _inherits3.default)(MenuButton, _Component);

  function MenuButton(props) {
    (0, _classCallCheck3.default)(this, MenuButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MenuButton.__proto__ || (0, _getPrototypeOf2.default)(MenuButton)).call(this, props));

    _this.handleTrigger = function () {
      if (_this.state.active) {
        document.removeEventListener('click', _this.closeMenuOnOutsideClick);
      } else {
        document.addEventListener('click', _this.closeMenuOnOutsideClick);
      }
      _this.setState({
        active: !_this.state.active
      });
    };

    _this.closeMenu = function () {
      _this.setState({
        active: false
      });
      document.removeEventListener('click', _this.closeMenuOnOutsideClick);
    };

    _this.closeMenuOnOutsideClick = function () {
      _this.closeMenu();
    };

    _this.state = {
      active: false
    };
    return _this;
  }

  (0, _createClass3.default)(MenuButton, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // removes the document event listener when navigating away from route
      this.closeMenu();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          split = _props.split,
          onClick = _props.onClick,
          children = _props.children,
          contentComponent = _props.contentComponent,
          block = _props.block,
          rest = (0, _objectWithoutProperties3.default)(_props, ['split', 'onClick', 'children', 'contentComponent', 'block']);

      var hasMini = (0, _keys2.default)(this.props).includes('mini');
      var ContentComponent = contentComponent;

      return _react2.default.createElement(
        MenuButtonContainer,
        null,
        _react2.default.createElement(
          _Button2.default,
          (0, _extends3.default)({
            outline: true,
            style: split ? mainButtonStyles : null,
            onClick: split ? onClick : this.handleTrigger,
            block: block
          }, rest),
          children,
          !split && _react2.default.createElement(
            'div',
            { style: { marginLeft: '10px' } },
            _react2.default.createElement(_icon2.default, { arrowDown: true, light: true, size: hasMini ? 0.8 : 1 })
          )
        ),
        split && _react2.default.createElement(
          _Button2.default,
          (0, _extends3.default)({ outline: true, style: toggleButtonStyles, onClick: this.handleTrigger }, rest),
          _react2.default.createElement(_icon2.default, { arrowDown: true, light: true, size: hasMini ? 0.8 : 1 })
        ),
        this.state.active && _react2.default.createElement(ContentComponent, null)
      );
    }
  }]);
  return MenuButton;
}(_react.Component);

MenuButton.displayName = 'MenuButton';
MenuButton.propTypes = {
  block: _propTypes2.default.bool,
  children: _propTypes2.default.string,
  contentComponent: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  split: _propTypes2.default.bool
};
MenuButton.defaultProps = {
  block: false,
  children: '',
  contentComponent: function contentComponent() {
    return null;
  },
  onClick: null,
  split: false
};
exports.default = MenuButton;
//# sourceMappingURL=MenuButton.js.map


//////////////////
// WEBPACK FOOTER
// ../button/lib/MenuButton.js
// module id = 147
// module chunks = 0